import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getActiveLanguage } from 'react-localize-redux';
import * as actionCreators from '../../_store/actions/index';

import Aux from '../_Aux';

const withErrorHandler = ( WrappedComponent, axios ) => {
    class errorHandler extends Component {
        state = {
            needsLogout : false
        }
        constructor (props) {
            super(props)
            this.reqInterceptor = axios.interceptors.request.use( req => {
                if(req.token) {
                    req.headers["Authorization"] = "melco " + req.token;
                }
                else if(this.props.auth.isAuthenticated) {
                    req.headers["Authorization"] = "melco " + this.props.auth.token;
                }
                if(req.impersonation_for_id) {
                    req.headers["x-melco-impersonate"] = req.impersonation_for_id;
                }
                else if(this.props.auth.impersonation_for_id) {
                    req.headers["x-melco-impersonate"] = this.props.auth.impersonation_for_id;
                }
                if(this.props.currentLanguage) {
                    req.headers["x-display-culture"] = this.props.currentLanguage;
                    req.headers["x-user-culture"] = this.props.currentLanguage;
                }
                this.props.onFetchingStart(!req.hideGlobalSpinner ? true : false ); 
                return req;
            } );
            this.resInterceptor = axios.interceptors.response.use( res => {
                this.props.onFetchingStop(); 
                return res;
            }, error => {
                this.props.onFetchingStop(); 
                const { skipRedirectToLoginIfUnauthorized } = error.config;
                //Unauthorized?
                if(error.response && error.response.status && error.response.status === 401 && !skipRedirectToLoginIfUnauthorized) {
                    // redirect to account app
                    window.location.href = `${process.env.REACT_APP_ACCOUNT_URL}?error=expired&redirectTo=${window.location}`;
                }
                if(error.response && error.response.data) {
                    return Promise.reject(error.response.data);
                }
                else {
                    return Promise.reject(error);                    
                }
            } );
        }

        componentWillUnmount () {
            axios.interceptors.request.eject( this.reqInterceptor );
            axios.interceptors.response.eject( this.resInterceptor );
        }

        render () {
            return (
                <Aux>
                    <WrappedComponent {...this.props} />
                </Aux>
            );
        }
    }
    const mapStateToProps = state => {
        return {
            auth: state.auth,
            currentLanguage: getActiveLanguage(state.locale).code
        };
    };

    const mapDispatchToProps = dispatch => {
    return {
        onFetchingStart: (showGlobalSpinner) => dispatch(actionCreators.fetchingStart(showGlobalSpinner)),
        onFetchingStop: () => dispatch(actionCreators.fetchingStop()),
    }
};
    return connect(mapStateToProps,mapDispatchToProps)(errorHandler);
}

export default withErrorHandler;


// WEBPACK FOOTER //
// ./src/_hoc/withErrorHandler/index.js